import { ChoicePicker, ChoicePickerOption } from "./ChoicePicker";
import { useTranslation } from "react-i18next";


interface DigitalDevicePickerProps {
    setDigitalDevice: (data: any) => void;
    required?: boolean;
    value: DigitalDeviceOption[] | undefined;
}

export interface DigitalDeviceOption extends ChoicePickerOption {
    id: string;
    name: string
}

export const DigitalDevicePicker = (props: DigitalDevicePickerProps) => {
    const { t } = useTranslation();
    
    const data: ChoicePickerOption[] = [
        {id: "desktop", name: t("txt_digital_device_desktop")},
        {id: "mobile", name: t("txt_digital_device_mobile")},
        {id: "tablet", name: t("txt_digital_device_tablet")},
        {id: "in-app", name: t("txt_digital_device_in-app")},
        {id: "web", name: t("txt_digital_device_web")},
    ]

    return (
        <ChoicePicker
            setSelectedData={props.setDigitalDevice}
            placeholder={t("txt_digital_device")}
            data={data}
            multiple={true}
            required={props.required}
            controlId="digitalDevicePicker"
            value={props.value ? props.value : []}
        />
);
}